// Main thread WASM guard
(() => {
  const orig = WebAssembly.instantiateStreaming as any;
  (WebAssembly as any).instantiateStreaming = async (resp: Promise<Response> | Response, imports?: any) => {
    const r = await (resp instanceof Promise ? resp : Promise.resolve(resp));
    const ct = r.headers.get('content-type') || '';
    const u  = (r as any).url || '[no-url]';
    console.warn('[MAIN][WASM STREAM] url=', u, 'ct=', ct);
    console.warn('[MAIN][WASM STREAM] stack=', new Error().stack);
    return orig ? orig(Promise.resolve(r), imports) : WebAssembly.instantiate(await r.arrayBuffer(), imports);
  };

  // Trap fetches for .wasm in MAIN
  const ofetch = fetch;
  (globalThis as any).fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : (input as any)?.url || String(input);
    const res = await ofetch(input as any, init);
    if (url.endsWith('.wasm')) {
      const ct = res.headers.get('content-type') || '';
      console.warn('[MAIN][WASM FETCH]', url, 'ct=', ct, 'status=', res.status);
      if (!ct.includes('wasm') && !ct.includes('octet-stream')) {
        const preview = await res.clone().text().catch(()=> '');
        console.warn('[MAIN][WASM BAD BYTES]', url, preview.slice(0, 120));
      }
    }
    return res;
  };
})();
